import React from 'react'
import { AllowedUpdateActionList } from '../../../models/Case'
import { Tooltip } from '../../ui/Tooltip/Tooltip'
import { L } from '../../providers/Lokalise'
import { Typography } from '../../ui/Typography/Typography'

type RestrictElementWithTooltipProps = {
    children: React.ReactNode
    restrictedAction: boolean
}

const RestrictElementWithTooltip: React.FC<RestrictElementWithTooltipProps> = ({
    children,
    restrictedAction,
}) => {
    if (restrictedAction) {
        return (
            <Tooltip content={L('LØN_TOOLTIP_TAG_SAGEN_FOR_AT_BRUGE_FUNKTION')}>
                <span style={{ cursor: 'not-allowed' }}>{children}</span>
            </Tooltip>
        )
    }

    return <>{children}</>
}

export { RestrictElementWithTooltip }
